import { Button } from "react-bootstrap";
import styled from "styled-components";

const TableActionButton = styled(Button).attrs({
  className: "bg-light text-black border-light",
})`
  padding: 0.2rem 0.4rem;
  pointer-events: ${(props) => (props.disabled ? "all" : "auto")};

  &:hover,
  &:focus,
  &:active {
    background-color: #c1efd2 !important;
    color: black !important;
    border-color: #c1efd2 !important;
  }

  &:disabled {
    background-color: #f5f5f5;
    border-color: #e0e0e0;
    color: #a0a0a0;
    cursor: not-allowed;
  }

  transition: all 0.3s ease;
`;

export default TableActionButton;
